import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardDossierStatesDefinition } from '../create-dossier-states-definition';
import { DossierShell } from '../dossier-shell.profile';
import {
  DossierOnionMetricProfile,
  dossierOnionEconomicParticipantProfile,
  dossierOnionEmployedProfile,
  dossierOnionGvaProfile,
  dossierOnionRevenueProfile,
  dossierOnionTaxedProfile,
} from './dashboard-dossier-states-onion-metric.profile';
import { DashboardDossierStatesOnionDefinition } from './dashboard-dossier-states-onion.definition';

/**
 * Product catalog for dossier states onion (marktquerschnitt).
 * Identity is derived in {@link createDashboardDossierStatesDefinition}.
 */

// Pending datasets: Tourism and SelfEmployed dossiers.
type DossierOnionMetric = Exclude<Metric, Metric.Tourism | Metric.SelfEmployed>;

export const DOSSIER_STATES_ONION_PRODUCT_CATALOG: Record<
  DossierOnionMetric,
  ProductCatalogEntry<DossierOnionMetricProfile, DossierShell>
> = {
  [Metric.CompaniesCount]: {
    metric: dossierOnionTaxedProfile,
    shells: ['onion'],
  },
  [Metric.CompaniesRevenue]: {
    metric: dossierOnionRevenueProfile,
    shells: ['onion'],
  },
  [Metric.GrossValueAdded]: {
    metric: dossierOnionGvaProfile,
    shells: ['onion'],
  },
  [Metric.EconomicParticipant]: {
    metric: dossierOnionEconomicParticipantProfile,
    shells: ['onion'],
  },
  [Metric.Employed]: {
    metric: dossierOnionEmployedProfile,
    shells: ['onion'],
  },
};

/** All dossier states onion (marktquerschnitt) product definitions. */
export const DOSSIER_STATES_ONION_DEFINITIONS: DashboardDossierStatesOnionDefinition[] =
  expandProductCatalog(
    Object.values(DOSSIER_STATES_ONION_PRODUCT_CATALOG),
    createDashboardDossierStatesDefinition,
  );
